import React from "react";
import { withRouter } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from "../../../util/IntlMessages";
import AllCoachTable from "./components/AllCoachTable";
import { connect } from "react-redux";
import {
    getAllCoaches,
    getAllCoachesSuccess
} from '../../../actions/CoachAction';
import { tsToDate } from "../../../util/dateUtil"
import { toTitleCase } from "../../../util/generalUtil"
import ContainerHeader from '../../../components/ContainerHeader'

class Coaches extends React.Component {
    constructor() {
        super()
        this.state = {
            coachesData: []
        }
    }

    componentDidMount() {
        const sessionToken = this.props.auth.authUser.sessionToken;
        const allCoaches = this.props.allCoaches;
        if (allCoaches != null && allCoaches.length > 0) {
            this.updateCoaches(allCoaches);
        } else {
            this.props.getAllCoaches({ sessionToken });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.allCoaches.length !== this.props.allCoaches.length) {
            this.updateCoaches(this.props.allCoaches);
        }
    }

    updateCoaches(allCoaches) {
        var localAllCoaches = [];
        allCoaches.forEach(coachObj => {
            const coach = ["", coachObj.hasOwnProperty("fullName") ? toTitleCase(coachObj.fullName) : "", coachObj.hasOwnProperty("uid") ? coachObj.uid : "", coachObj.hasOwnProperty("playerInfo") ? (coachObj.playerInfo.hasOwnProperty("phone") ? coachObj.playerInfo.phone : "") : "", coachObj.hasOwnProperty("playerInfo") ? (coachObj.playerInfo.hasOwnProperty("gender") ? coachObj.playerInfo.gender : "male") : "male", coachObj.hasOwnProperty("playerInfo") ? (coachObj.playerInfo.hasOwnProperty("dateOfBirthTs") ? tsToDate(coachObj.playerInfo.dateOfBirthTs) : "") : "", coachObj.hasOwnProperty("playerInfo") ? (coachObj.playerInfo.hasOwnProperty("city") ? coachObj.playerInfo.city : "") : "", coachObj.hasOwnProperty("playerInfo") ? (coachObj.playerInfo.hasOwnProperty("country") ? coachObj.playerInfo.country : "") : "", coachObj.hasOwnProperty("startDateTs") ? tsToDate(coachObj.startDateTs) : "", coachObj.hasOwnProperty("status") ? coachObj.status : ""];
            localAllCoaches.push(coach);
        });
        console.log("localAllCoaches : " + localAllCoaches);
        this.setState({ coachesData: localAllCoaches });
    }

    render() {
        return (
            <div className="app-wrapper">
                <div className="dashboard animated slideInUpTiny animation-duration-3">
                    {/* <div style={{ padding: '20px 20px 20px 20px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center ">
                        <h2 className="title mb-3 mb-sm-0">{<IntlMessages id="coaches.title" />}</h2>
                    </div> */}
                    <ContainerHeader
                        match={this.props.match}
                        title={<IntlMessages id="coaches.title" />}
                    />
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 col-12">
                            {this.props.allCoachLoader ? (
                                <div>
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 130 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                    <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                </div>
                            ) : (
                                    <AllCoachTable
                                        coachesData={this.state.coachesData}
                                    />
                                )}
                        </div>
                    </div>

                </div>
            </div>
        );
    }

}

const mapStateToProps = ({ settings, coach, auth }) => {
    const { width, drawerType, navigationStyle, horizontalNavPosition } = settings;
    const { allCoaches, allCoachLoader } = coach;
    return { width, drawerType, navigationStyle, horizontalNavPosition, allCoaches, allCoachLoader, auth }
}
export default withRouter(connect(mapStateToProps, {
    getAllCoaches,
    getAllCoachesSuccess
})(Coaches));
